/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%] {\n  position: relative;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n[_nghost-%COMP%]   .shadow[_ngcontent-%COMP%] {\n  position: absolute;\n  top: -80px;\n  z-index: 9;\n  left: -11vw;\n  width: 46vw;\n  height: 63px;\n  background-image: -webkit-gradient(linear, left bottom, left top, from(#000000), color-stop(20%, #000000), to(rgba(0, 0, 0, 0)));\n  background-image: linear-gradient(to top, #000000, #000000 20%, rgba(0, 0, 0, 0));\n}"];
export { styles as styles };
